import { css } from '@emotion/core';
import styled from '@emotion/styled';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';
import createSharedStyles from './Avatar.shared.style';

const sharedStyles = createSharedStyles(css, theme, styleUtils);

export const AvatarContainer = styled('div')`
  ${sharedStyles.container.base};
  position: relative;
  ${(props) => sharedStyles.bySize[props.size]};
  ${(props) =>
    !props.hasImage ? sharedStyles.container.background(props.name) : null}
`;

export const Image = styled('img')`
  ${sharedStyles.image.base};
  object-fit: cover;
  ${(props) => sharedStyles.bySize[props.size]};
`;

const container = css`
  ${sharedStyles.container.base};
  position: relative;
`;

const image = css`
  ${sharedStyles.image.base};
  object-fit: cover;
`;

export default {
  ...sharedStyles,
  container: {
    ...sharedStyles.container,
    base: container,
  },
  image: {
    base: image,
  },
};
